export const ORDER_STATUS = {
  awaiting_payment: "Attesa pagamento", paid: "Pagato", processing: "In preparazione", shipped: "Spedito", delivered: "Consegnato", completed: "Completato",
  cancelled: "Annullato", expired: "Scaduto", refunded: "Rimborsato", partially_refunded: "Rimborso parziale",
};
export const ORDER_TONE = {
  awaiting_payment: "bg-amber-50 text-amber-700", paid: "bg-emerald-50 text-emerald-700", processing: "bg-sky-50 text-sky-700", shipped: "bg-indigo-50 text-indigo-700",
  delivered: "bg-emerald-50 text-emerald-700", completed: "bg-emerald-50 text-emerald-700", cancelled: "bg-slate-100 text-slate-500", expired: "bg-slate-100 text-slate-500",
  refunded: "bg-sky-50 text-sky-700",
};
export const NEXT_LABEL = { processing: "In preparazione", shipped: "Segna spedito", delivered: "Segna consegnato", completed: "Segna completato" };
export const emptyVariant = () => ({ sku: "", options: {}, price: "", compare: "", track_stock: true, stock: 0, active: true, interval: "month", interval_count: 1 });

// Internal (non-fiscal) receipt HTML opened in a new tab with the Studio session (the admin route needs the Bearer token).
export async function openDocument(api, tid, id, onError) {
  const w = window.open("", "_blank");
  try { const { data } = await api.get(`/t/${tid}/shop/documents/${id}/html`, { responseType: "text" }); w.document.write(data); w.document.close(); } catch (e) { w.close(); onError(e); }
}
